class DDRadialClaims extends HTMLElement {
  connectedCallback() {
    if (this.dataset.animation !== 'reveal' && !this.classList.contains('dd-radial-claims-core--arrow-draw')) return;

    this.dataset.motionReady = '';
    this.onArrowTransitionEnd = (event) => {
      if (event.propertyName !== 'stroke-dashoffset' || !event.target.classList.contains('dd-radial-claims-core__mask-head')) return;
      event.target.closest('[data-dd-radial-mask]')?.setAttribute('data-draw-complete', '');
    };
    this.addEventListener('transitionend', this.onArrowTransitionEnd);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      this.dataset.revealed = '';
      return;
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry?.isIntersecting) return;
        this.dataset.revealed = '';
        this.observer?.disconnect();
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    if (this.onArrowTransitionEnd) this.removeEventListener('transitionend', this.onArrowTransitionEnd);
  }
}

if (!customElements.get('dd-radial-claims')) customElements.define('dd-radial-claims', DDRadialClaims);
